import React from 'react';
import MobileListItem from './mobileListElements/MobileListItem';
import _ from 'lodash';
import styles from './CartItemsMobileList.scss';
import {divider} from 'src/styles/common.scss';

export default function CartItemsMobileList(props) {
  const items = _.map(props.items, (item) => (
    <div>
      <MobileListItem item={item} key={`list_item_${item.CartDetailId}`} />
      <div className={divider + ' ' + styles.itemsDivider} />
    </div>
  ));
  return (
    <div className={styles.cartItemsMobileList}>
      <div className={divider + ' ' + styles.itemsDivider} />
      {items}
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/components/Cart/elements/CartItemsMobileList.jsx
 **/